import React from 'react'

import { useTranslation } from '@guiker/i18n'
import { CommercialIcon, ResidentialIcon, SquareFootageIcon } from '@guiker/icons'
import { BuildingTypes, Unit, UnitType } from '@guiker/real-estate-shared'

import { Flex } from '..'
import { IconDescription } from './iconDescription'
import { findBuildingIcon, findTotalNumberOfUnitType, findTotalSquareFootage } from './utils'

type MixedUnitConfigProp = {
  units: Unit[]
  buildingType: BuildingTypes
}

export const MixedUnitConfig: React.FC<MixedUnitConfigProp> = ({ buildingType, units }) => {
  const { t } = useTranslation('common-realEstate')

  const BuildingIcon = findBuildingIcon(buildingType)
  const totalSquareFootage = findTotalSquareFootage(units)
  const totalResidentialUnits = findTotalNumberOfUnitType(units, UnitType.RESIDENTIAL)
  const totalCommercialUnits = findTotalNumberOfUnitType(units, UnitType.COMMERCIAL)

  return (
    <Flex padding={2} justifyContent='space-evenly' width='100%' flexWrap='wrap' gap={3}>
      <IconDescription
        icon={<BuildingIcon />}
        description={t(`unitConfiguration.building.${buildingType}`)}
        value={''}
      />
      <IconDescription
        icon={<ResidentialIcon />}
        description={t('unitConfiguration.residential', { count: totalResidentialUnits })}
        value={totalResidentialUnits.toLocaleString()}
      />
      <IconDescription
        icon={<CommercialIcon />}
        description={t('unitConfiguration.commercial', { count: totalCommercialUnits })}
        value={totalCommercialUnits.toLocaleString()}
      />
      <IconDescription
        icon={<SquareFootageIcon />}
        description={t('unitConfiguration.squareFootage')}
        value={totalSquareFootage.toLocaleString()}
      />
    </Flex>
  )
}
